import { Grid, Skeleton } from '@mui/material';
import dayjs from 'dayjs';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import { useGlobals } from 'src/shared/contexts/appContext';
import { AssociationAndDistrictSelect } from 'src/shared/components/organisms/associationAndDistrictSelect';
import { District } from 'src/shared/models/district/district';
import { Association } from 'src/shared/models/association/association';
import { useState } from 'react';
import { getSysProducts } from 'src/shared/functions/getSysProducts';
import { SysProductYvNameEnum } from 'src/shared/models/enums/sysProductEnums';
import { MemberDashboard } from '../components/members/memberDashboard';
import { GetGreetingsHeader } from '../components/atoms/greetingsHeader';
import { MemberDashboardLog } from '../components/members/memberDashboardLog';
import { TodoWidget } from '../components/todoWidget';
import { responsiveSpacing } from '../models/responsiveSpacing';
import { InvoiceMissionApprovalAlert } from '../components/invoiceMission/invoiceMissionApprovalAlert';

export const DashboardUser = () => {
  const { currentUser } = useGlobals();

  const [association, setAssociation] = useState<Association>();
  const [district, setDistrict] = useState<District>();

  const sysProducts = getSysProducts(currentUser);
  const hasMemberReg = sysProducts.some((x) => x.yvName.toLowerCase() === SysProductYvNameEnum.MemberReg.toLowerCase());

  return (
    <Grid container spacing={3}>
      <Grid item xs>
        <MainContentHeader
          isLoading={currentUser?.firstName === undefined}
          title={`${GetGreetingsHeader()}, ${currentUser?.firstName}`}
          subtitle={`${dayjs(new Date()).format('D MMM YYYY')}`}
        />
      </Grid>
      {hasMemberReg && (
        <>
          <Grid
            item
            xs='auto'
            sx={{
              py: 2,
              pl: 2,
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: 'flex-end',
              '& .MuiAutocomplete-inputRoot': {
                backgroundColor: 'white',
              },
            }}
          >
            {currentUser ? (
              <AssociationAndDistrictSelect
                hideDistrict={currentUser?.districts.length === 0}
                association={association}
                district={district}
                associationCallback={(val) => setAssociation(val || undefined)}
                districtCallback={(val) => setDistrict(val || undefined)}
              />
            ) : (
              <Skeleton sx={{ width: '25vw' }} />
            )}
          </Grid>
          <Grid item xs={12}>
            <InvoiceMissionApprovalAlert />

            <Grid container spacing={responsiveSpacing}>
              <Grid item xs={12} lg={9}>
                <Grid container spacing={responsiveSpacing}>
                  <MemberDashboard associationId={association?.localAss_id} districtId={district?.countyAss_id} />
                </Grid>
              </Grid>
              <Grid item xs={12} lg={3}>
                <TodoWidget />
                <MemberDashboardLog associationId={association?.localAss_id} districtId={district?.countyAss_id} />
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </Grid>
  );
};
